const responseCache = {};
const listeners = {};
export const REQUEST_STATUS = {
  PENDING: 'PENDING',
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  COMPLETE: 'COMPLETE',
  DELETED: 'DELETED'
};

export const notifyListeners = ({ key, data }) => {
  if (!Array.isArray(listeners[key])) {
    return;
  }

  listeners[key].forEach(listener => {
    listener(data);
  });
};

export const reset = () => {
  for (const key in responseCache) {
    if (responseCache.hasOwnProperty(key)) {
      delete responseCache[key];
    }
  }
};

export const getCacheForKey = key => responseCache[key];

export const setCacheForKey = ({ key, value }, { notify = false } = {}) => {
  responseCache[key] = value;
  if (notify) {
    notifyListeners({ key, data: value });
  }
};

export const deleteCacheForKeys = (keys, { notify = false } = {}) => {
  keys.forEach(key => {
    delete responseCache[key];
    if (notify) {
      notifyListeners({ key, data: { status: REQUEST_STATUS.DELETED } });
    }
  });
};

export const attachListener = ({ key, listener }) => {
  if (!Array.isArray(listeners[key])) {
    listeners[key] = [];
  }

  listeners[key].push(listener);
};

export const removeListener = ({ key, listener }) => {
  if (!Array.isArray(listeners[key])) {
    return;
  }

  listeners[key] = listeners[key].filter(savedListener => savedListener !== listener);
};

export const writeDataToCache = ({ status, data, cacheKey }) => {
  const { status: cachedStatus, data: cachedData } = getCacheForKey(cacheKey) || {};

  setCacheForKey(
    {
      key: cacheKey,
      value: {
        status: status || cachedStatus,
        data: data || cachedData
      }
    },
    { notify: true }
  );
};
